import * as React from 'react';
import { useState } from 'react';
import { User, Group } from '../../../services/permissionService';
import styles from './AdminOverview.module.css';

interface ChangeGroupsModalProps {
  user: User;
  availableGroups: Group[];
  onUpdate: (groupIds: number[]) => Promise<void>;
  onClose: () => void;
  loading: boolean;
}

export function ChangeGroupsModal({ user, availableGroups, onUpdate, onClose, loading }: ChangeGroupsModalProps): React.JSX.Element {
  const [selectedGroupIds, setSelectedGroupIds] = useState<number[]>(
    user.groups.map(g => g.id)
  );

  function handleGroupToggle(groupId: number): void {
    setSelectedGroupIds(prev =>
      prev.includes(groupId)
        ? prev.filter(id => id !== groupId)
        : [...prev, groupId]
    );
  }

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        <h2 className={styles.modalTitle}>
          Change Groups for {user.first_name} {user.last_name}
        </h2>

        <div className={styles.modalSection}>
          <h3 className={styles.modalSectionTitle}>Select Groups</h3>
          <div className={styles.checkboxList}>
            {availableGroups.map(group => (
              <label
                key={group.id}
                className={`${styles.checkboxItem} ${selectedGroupIds.includes(group.id) ? styles.checkboxItemSelected : ''}`}
              >
                <input
                  type="checkbox"
                  checked={selectedGroupIds.includes(group.id)}
                  onChange={() => handleGroupToggle(group.id)}
                  style={{ margin: 0 }}
                />
                <span>{group.name}</span>
              </label>
            ))}
          </div>
        </div>

        <div className={styles.buttonRow}>
          <button onClick={onClose} disabled={loading} className={styles.cancelButton}>
            Cancel
          </button>
          <button
            onClick={() => onUpdate(selectedGroupIds)}
            disabled={loading}
            className={styles.submitButton}
          >
            {loading ? 'Updating...' : 'Update Groups'}
          </button>
        </div>

        <button onClick={onClose} className={styles.modalClose} aria-label="Close">
          &times;
        </button>
      </div>
    </div>
  );
}
